import {
  REQUEST_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT,
  RECEIVE_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT,
  RECEIVE_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT_ERROR,
} from '../actions/loggedOutHomePageStatic';

export const initialState = {
  isFetching: false,
  isReceived: false,
  sections: [],
};

export default function loggedOutHomePageStatic(state = initialState, action) {
  switch (action.type) {
    case REQUEST_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT:
      return {
        ...state,
        ...action.content,
        isFetching: false,
        isReceived: true,
      };
    case RECEIVE_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    default:
      return state;
  }
}
